module.exports = __webpack_public_path__ + "img/edit.6f230355.svg";